import React from 'react';
import { Field } from 'redux-form';
import isBoolean from 'lodash/isBoolean';

import FormField, { renderLabel, renderDescription, renderSubtext } from './form-field';

import RenderSpecialConsumerField from './render-special-consumer-field';

import {
  SINGLE_SELECT,
  MULTI_SELECT,
  TEXT,
  TEXTAREA,
  ADDRESS,
  DATETIME,
  SINGLE_SELECT_DEFAULT_VALUE,
} from '../lib/custom-field-types';

import textFromAddress from '../lib/consumer-fields/text-from-address';

const renderConsumerField = (fieldConfig) => {
  const { type } = fieldConfig;
  switch (type) {
    case TEXT:
    case TEXTAREA:
    case MULTI_SELECT:
    case ADDRESS:
    case DATETIME:
      return renderGenericField(fieldConfig);
    case SINGLE_SELECT:
      if (fieldConfig.special) {
        return <Field
          {...fieldConfig}
          component={RenderSpecialConsumerField}
        />
      }

      return renderListConsumerField(fieldConfig)
    default:
      return null;
  }
};

export const renderGenericField = (fieldConfig) => {
  const placeholder = getPlaceholder(fieldConfig);
  return (
    <div className={`consumer-field ${fieldConfig.type.toLowerCase()}-field`} key={fieldConfig.key}>
      <Field {...fieldConfig} component={FormField} placeholder={placeholder} />
    </div>
  );
};

const getPlaceholder = (fieldConfig) => {
  if (fieldConfig.type === TEXT || fieldConfig.type === TEXTAREA) {
    return fieldConfig.defaultValue;
  } else if (fieldConfig.type === DATETIME && !fieldConfig.value) {
    return 'i.e. 02 Dec 2027 12:00 am';
  }
}

const renderListConsumerField = (fieldConfig) => {
  return (
    <div className="consumer-field single-select-field" key={fieldConfig.key}>
      <div className="form-group">
        {renderLabel(fieldConfig.label, fieldConfig.required, fieldConfig.id)}
        {renderDescription(fieldConfig.description)}
        <Field
          {...fieldConfig}
          defaultValue={fieldConfig.defaultValue || SINGLE_SELECT_DEFAULT_VALUE}
          component={renderSelect}
          options={buildListOptions(fieldConfig.options)}
        />
      </div>
    </div>
  );
};

const renderSelect = field => {
  const {
    subtext, meta: { touched, error }
  } = field;
  const cssClass = touched && error ? 'has-danger' : '';
  return (
    <div className={cssClass}>
      <select {...field.input} className="custom-select">
        <option value="">Choose one</option>
        {
          field.options.map((opt, i) => <option value={opt.value || 'null'} key={`opt-${i}`}>{opt.text}</option>)
        }
      </select>
      <br />
      {renderSubtext(subtext, touched && error)}
    </div>
  );
};

export const buildListOptions = (options) => {
  return [
    ...options.map(({ value, type }) => {
      let _value = value;

      if (isBoolean(value)) {
        _value = JSON.stringify(value);
      }

      if (type === 'address') return { value, text: textFromAddress(value) };
      return { value: _value, text: _value };
    })
  ];
};

export default renderConsumerField;



// WEBPACK FOOTER //
// ./src/desktop/components/render-consumer-field.js